export default function timeConverter(time: number) {
    const dateObject = new Date(time * 1000)
    return {
        year: dateObject.getUTCFullYear().toString(),
        month: (dateObject.getUTCMonth() + 1).toString(),
        day: dateObject.getUTCDate().toString(),
        hour: dateObject.getUTCHours().toString(),
        minute: dateObject.getUTCMinutes().toString(),
        week: dateObject.getUTCDay().toString()
    }
}
